module.exports = __webpack_public_path__ + "static/media/country_cz.4edc80de.webp";